import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import { LocaleProvider } from './i18n/LocaleContext';
import { FavouritesProvider } from './favourites/FavouritesContext';
import HomePage from './pages/HomePage';
import EventDetailPage from './pages/EventDetailPage';
import FavouritesPage from './pages/FavouritesPage';
import LegalPage from './pages/LegalPage';
import './App.css';

export default function App() {
  return (
    <LocaleProvider>
      <FavouritesProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/favourites" element={<FavouritesPage />} />
            <Route path="/event/:id" element={<EventDetailPage />} />
            <Route path="/privacy" element={<LegalPage page="privacy" />} />
            <Route path="/contact" element={<LegalPage page="contact" />} />
            {/* The host serves index.html for every path, so a mistyped
                link would otherwise render an empty page. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </FavouritesProvider>
    </LocaleProvider>
  );
}
